export const LOAD_YEAR = "LOAD_YEAR";

export const loadYear = (year) => {
    return {type: "LOAD_YEAR", year: year}
};